import React from 'react';
import { World } from '../../types';
import { statusInfo } from '../../utils/format';

interface Props {
  world: World;
  selected: boolean;
  onClick: () => void;
  /** Shown under the name, e.g. "by owner_name" for worlds the viewer doesn't own. */
  subtitle?: React.ReactNode;
  /** Optional badge rendered before the status dot (unread count etc.). */
  badge?: React.ReactNode;
}

/** One world row in the rail. */
export const WorldItem: React.FC<Props> = ({ world, selected, onClick, subtitle, badge }) => {
  const st = statusInfo(world.status);
  return (
    <button type="button" className="witem" aria-current={selected} onClick={onClick} title={`${world.name} · ${st.text}`}>
      <span className="witem-name">
        {world.name}
        {subtitle && <small>{subtitle}</small>}
      </span>
      {badge}
      <span className={`dot ${st.dot}`} />
    </button>
  );
};

export default WorldItem;
